import * as Sentry from "@sentry/react";
import { Spinner } from "./components/commonComponents/Spinner/Spinner";

const ErrorBoundary = Sentry.withErrorBoundary(
  ({ children }) => children,
  {
    fallback: <Spinner />, // UI shown if component crashes
  }
);

export default ErrorBoundary;
